import styled from "styled-components";

const Table = styled.table`
  min-width: 100%;
`;

export default Table;
